<template>
	<v-card flat>
		<v-card-text>
			<smart-input v-model="filters.year" label="בחר שנה" required type="number" :min="2000"/>
			<smart-input required label="שם קובץ" v-model="filters.file_name"></smart-input>
		</v-card-text>
		<v-card-actions>
			<v-btn slot="actions" :disabled="!canExport" color="success" btn @click="exportExcel">
				{{$t("pages.measurementTable.exportExcel")}}
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>

	export default {
		name: "htm-year-report",
		props: [],
		components: {},
		data() {
			return {
				filters: {
					year: (new Date).getFullYear(),
					file_name: "דוח HTM"
				},

			};
		},
		computed: {
			isClient() {
				return this.$store.getters.isClient;
			},
			basicUrl() {
				return this.$store.state.ConfigModule.request.baseUrl;
			},
			canExport() {
				return this.filters.year;
			}
		},
		methods: {
			exportExcel() {
				let query = new URLSearchParams();
				Object.keys(this.filters).forEach(key => query.set(key, this.filters[key]));
				//let queryString = Object.keys(this.filters).map(key => key + "=" + this.filters[key]).join("&");
				window.open(`${this.basicUrl}/export/htm?a=1&${query}`);
			}
		},
		mounted() {
		}

	};
</script>

<style scoped>

</style>
